import { Theme } from '@emotion/react';

export const generateCardStyles = (theme: Theme) => ({
    iconWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '68px',
        '--hover-color': 'transparent',

        '& svg': {
            color: theme.palette.primary.main,
            width: '55px',
            maxHeight: '55px',
        },
    },
    title: {
        color: theme.palette.common.black,
        fontSize: '14px',
        fontWeight: 500,
        fontFamily: theme.palette.common.font,
        marginTop: '10px',
        letterSpacing: '0px',
    },
    description: {
        fontSize: '14px',
        lineHeight: 1.5,
        color: theme.palette.secondary.descriptionGrey,
        maxWidth: '202px',
        margin: '0 auto',
    },
});
